<app-nav
    [titulo]="medioPago ? 'Editar medio de pago: ' + medioPago.nombre : 'Nuevo medio de pago'"
    [descripcion]="medioPago ? 'Aquí podrá modificar los datos del medio de pago.' : 'Por favor complete todos los datos del nuevo medio de pago.'">
    <div class="edit-medio-pago basic-avm-editor">
        <div class="form-stepper">
            <form [formGroup]="form" class="form-step">

                <h3 class="form-step-title">{{ medioPago ? 'Editar medio de pago' : 'Nuevo medio de pago' }}</h3>
                <span class="form-step-description">
                    {{ medioPago ? 'Modificá los datos y guardá los cambios.' : 'Completá los datos del nuevo medio de pago.' }}
                </span>

                <div class="form-line">
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>Nombre</mat-label>
                        <input matInput formControlName="nombre" placeholder="Ej: Débito">
                        <mat-error *ngIf="form.controls['nombre'].hasError('required')">El nombre es requerido</mat-error>
                    </mat-form-field>
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>Clave</mat-label>
                        <input matInput formControlName="clave" placeholder="Ej: debito, credito3">
                        <mat-hint>Clave técnica usada por el motor de cotización</mat-hint>
                    </mat-form-field>
                </div>

                <div class="form-line">
                    <mat-form-field class="garantor-form-field" appearance="outline" style="max-width: 160px;">
                        <mat-label>Cuotas</mat-label>
                        <input matInput formControlName="cuotas" type="number">
                        <mat-error *ngIf="form.controls['cuotas'].hasError('required')">Las cuotas son requeridas</mat-error>
                    </mat-form-field>
                </div>

                <div class="form-line">
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>Coeficiente de ajuste</mat-label>
                        <input matInput formControlName="coeficienteAjuste" type="number" style="text-align: right;">
                        <mat-hint>Ej: 1.111111 para débito/crédito</mat-hint>
                        <mat-error *ngIf="form.controls['coeficienteAjuste'].hasError('required')">Requerido</mat-error>
                    </mat-form-field>
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>Costo de cobro</mat-label>
                        <input matInput formControlName="costoCobro" type="number" style="text-align: right;">
                        <span matSuffix>&nbsp;%</span>
                        <mat-error *ngIf="form.controls['costoCobro'].hasError('required')">Requerido</mat-error>
                    </mat-form-field>
                </div>

                <div class="form-line">
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>SIRTAC</mat-label>
                        <input matInput formControlName="sirtac" type="number" style="text-align: right;">
                        <span matSuffix>&nbsp;%</span>
                        <mat-error *ngIf="form.controls['sirtac'].hasError('required')">Requerido</mat-error>
                    </mat-form-field>
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>IIBB</mat-label>
                        <input matInput formControlName="iibb" type="number" style="text-align: right;">
                        <span matSuffix>&nbsp;%</span>
                        <mat-error *ngIf="form.controls['iibb'].hasError('required')">Requerido</mat-error>
                    </mat-form-field>
                </div>

                <mat-form-field class="garantor-form-field" appearance="outline">
                    <mat-label>C y D (Comisiones y Débitos)</mat-label>
                    <input matInput formControlName="cyd" type="number" style="text-align: right;">
                    <span matSuffix>&nbsp;%</span>
                    <mat-error *ngIf="form.controls['cyd'].hasError('required')">Requerido</mat-error>
                </mat-form-field>

                <mat-form-field class="garantor-form-field" appearance="outline" *ngIf="form.value.cuotas > 1">
                    <mat-label>Costo financiero (cuotas)</mat-label>
                    <input matInput formControlName="costoInt" type="number" style="text-align: right;">
                    <span matSuffix>&nbsp;%</span>
                    <mat-hint>Costo financiero del plan de cuotas (aplica IVA 21%)</mat-hint>
                </mat-form-field>

                <div class="form-radio-line">
                    <span class="radio-line-label">¿Aplica IVA?</span>
                    <div class="radios">
                        <mat-radio-group formControlName="aplicaIva">
                            <mat-radio-button [value]="true">Sí</mat-radio-button>
                            <mat-radio-button [value]="false">No</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>

                <mat-form-field class="garantor-form-field" appearance="outline" *ngIf="aplicaIva">
                    <mat-label>IVA</mat-label>
                    <input matInput formControlName="iva" type="number" style="text-align: right;">
                    <span matSuffix>&nbsp;%</span>
                </mat-form-field>

                <div class="form-radio-line">
                    <span class="radio-line-label">Estado</span>
                    <div class="radios">
                        <mat-radio-group formControlName="activo">
                            <mat-radio-button [value]="true">Activo</mat-radio-button>
                            <mat-radio-button [value]="false">Inactivo</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>

                <div class="form-step-buttons">
                    <button mat-button type="button" class="garantor-button" (click)="cancel()">Cancelar</button>
                    <button mat-raised-button color="primary" type="button" class="garantor-button" (click)="save()">
                        {{ medioPago ? 'Guardar cambios' : 'Crear medio de pago' }}
                    </button>
                </div>

            </form>
        </div>
    </div>
</app-nav>
